<p class="title">Conditional Formatting</p>

@if (displayType !== 'bar') {
    <div class="tab-header">
        @if (columnConditionVizTab[0].vizTabs.length > 0) {
            <app-visualization-nav-header
                #visualizationNavTabHeaderForCondition
                [vizTabs]="columnConditionVizTab"
                (removeTab)="removeConditionalFormatters($event.tab)">
            </app-visualization-nav-header>
        }

        <cc-icon
            class="add-visualization-icon"
            [icon]="'plus-circle'"
            [size]="'xsmall'"
            (iconClicked)="addConditionalFormatters()">
        </cc-icon>
    </div>

    @if (columnConditionVizTab[0].vizTabs.length > 0) {
        <div class="parent-tabtype">
            @for (vizTab of columnConditionVizTab[0].vizTabs; track vizTab.guid) {
                <div>
                    @if (vizTab.active) {
                        <div class="tab-details">
                            <div class="section empty">
                                <div class="subsection">
                                    <p class="title">If the value is</p>

                                    <div class="custom-select">
                                        <app-dropdown
                                            name="valuelabel"
                                            [options]="valueOperators"
                                            [selected]="vizTab.selectedOperatorCondition"
                                            (selectedChange)="onOperatorConditionChanged($event, vizTab)">
                                        </app-dropdown>
                                    </div>
                                </div>

                                <div class="subsection">
                                    <p class="title">&nbsp;</p>

                                    @if (displayType === 'value') {
                                        @if (vizTab.showInputRange) {
                                            <div class="range-type">
                                                <input
                                                    type="number"
                                                    name="rangefrom"
                                                    value="{{vizTab.columnCondition.rangeFrom}}"
                                                    (input)="onInput($event, numberRegex, vizTab.columnCondition, 'rangeFrom')" />

                                                <span>-</span>

                                                <input
                                                    type="number"
                                                    name="rangeto"
                                                    value="{{vizTab.columnCondition.rangeTo}}"
                                                    (input)="onInput($event, numberRegex, vizTab.columnCondition, 'rangeTo')" />
                                            </div>
                                        } @else {
                                            <input
                                                type="number"
                                                name="value"
                                                value="{{vizTab.columnCondition.value}}"
                                                (input)="onInput($event, numberRegex, vizTab.columnCondition, 'value')" />
                                        }
                                    } @else {
                                        @if (vizTab.showInputRange) {
                                            <div>
                                                <div class="range-type">
                                                    <input
                                                        type="text"
                                                        name="rangefrom"
                                                        value="{{vizTab.columnCondition.rangeFrom}}"
                                                        autocomplete="off"
                                                        placeholder="{{ displayType === 'date' ? acceptedDateFormat : '' }}"
                                                        (input)="onInput($event, displayType === 'date' ? dateRegex : null, vizTab.columnCondition, 'rangeFrom')" />

                                                    <span>-</span>

                                                    <input
                                                        type="text"
                                                        name="rangeto"
                                                        value="{{vizTab.columnCondition.rangeTo}}"
                                                        autocomplete="off"
                                                        placeholder="{{ displayType === 'date' ? acceptedDateFormat : '' }}"
                                                        (input)="onInput($event, displayType === 'date' ? dateRegex : null, vizTab.columnCondition, 'rangeTo')" />
                                                </div>
                                            </div>
                                        } @else {
                                            @if (vizTab.columnCondition.operatorCondition === 'ADO') {
                                                <div class="custom-select">
                                                    <app-dropdown
                                                        name="datelabel"
                                                        [options]="fuzzyDates"
                                                        (selectedChange)="onFuzzyDateChanged($event, vizTab.columnCondition)"
                                                        >
                                                    </app-dropdown>
                                                </div>
                                            } @else {
                                                <input
                                                    type="text"
                                                    name="value"
                                                    value="{{vizTab.columnCondition.value}}"
                                                    autocomplete="off"
                                                    placeholder="{{ displayType === 'date' ? acceptedDateFormat : '' }}"
                                                    (input)="onInput($event, displayType === 'date' ? dateRegex : null, vizTab.columnCondition, 'value')" />
                                            }
                                        }
                                    }

                                </div>
                            </div>

                            <div class="section empty">
                                <div class="subsection font-cell">
                                    <p class="title">Set Cell and Font Color</p>

                                    <ddv-cell-and-font-color
                                        [cellValue]="vizTab.columnCondition.cellColor"
                                        [fontValue]="vizTab.columnCondition.fontColor"
                                        [cellAndFontColors]="cellAndFontColors"
                                        (colorSelected)="onCellFontColorSelected(vizTab.columnCondition, $event)"
                                    >
                                    </ddv-cell-and-font-color>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }
} @else {
    @for (vizTab of columnConditionVizTab[0].vizTabs; track vizTab.guid) {
        <div class="section empty progress-bar-type">
            <div class="subsection">
                <p class="title">Type</p>

                <div class="custom-select">
                    <app-dropdown
                        name="operatorCondition"
                        [options]="valueOperators"
                        [selected]="vizTab.selectedOperatorCondition"
                        (selectedChange)="onBarConditionChanged(vizTab.columnCondition, $event)">
                    </app-dropdown>
                </div>
            </div>

            <div class="subsection value" [hidden]="vizTab.columnCondition.operatorCondition === 'AUTO'">
                <p class="title">Value</p>

                <div class="range-type">
                    <input
                        type="number"
                        name="rangefrom"
                        value="{{vizTab.columnCondition.rangeFrom}}"
                        min="{{vizTab.columnCondition.operatorCondition === 'PRCT' ? 0 : ''}}"
                        max="{{vizTab.columnCondition.operatorCondition === 'PRCT' ? 100 : ''}}"
                        placeholder="MIN"
                        (input)="onInput($event, vizTab.columnCondition.operatorCondition === 'NUM' ? numberRegex : barPercentRegex, vizTab.columnCondition, 'rangeFrom')" />

                    <span>-</span>

                    <input
                        type="number"
                        name="rangeto"
                        value="{{vizTab.columnCondition.rangeTo}}"
                        min="{{vizTab.columnCondition.operatorCondition === 'PRCT' ? 0 : ''}}"
                        max="{{vizTab.columnCondition.operatorCondition === 'PRCT' ? 100 : ''}}"
                        placeholder="MAX"
                        (input)="onInput($event, vizTab.columnCondition.operatorCondition === 'NUM' ? numberRegex : barPercentRegex, vizTab.columnCondition, 'rangeTo')" />
                </div>
            </div>

            <div class="section empty">
                <div class="subsection">
                    <p class="title">Bar Color</p>

                    <ddv-bar-color
                        [value]="vizTab.columnCondition.barColor"
                        [barColors]="barColors"
                        (colorSelected)="onBarColorSelected(vizTab.columnCondition, $event)"
                    >
                </ddv-bar-color>
                </div>
            </div>
        </div>
    }
}
